var _path, _path2;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgZone2 = function SvgZone2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 29,
    fill: "none",
    viewBox: "0 0 24 29",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.97,
    d: "M23.996 17.69a.82.82 0 0 0-.51-.69l-6.489-3.274c1.262-2.583 2.223-5.046 2.223-6.518C19.22 3.244 15.976 0 12.012 0S4.803 3.244 4.803 7.208c0 1.622 1.172 4.445 2.613 7.329l-4.264.72a1 1 0 0 0-.691.511L.088 20.994c-.21.42-.03.962.39 1.172l11.324 6.217c.15.06.3.12.45.12.06 0 .12 0 .18-.03l9.672-1.982c.27-.06.51-.24.63-.48.12-.241.12-.541.03-.782l-1.922-4.295 2.884-2.492c.18-.151.3-.451.27-.752M11.982 1.832a5.37 5.37 0 0 1 5.376 5.376c0 1.622-1.832 5.767-4.896 11.083a.57.57 0 0 1-.48.27.57.57 0 0 1-.481-.27c-3.063-5.316-4.895-9.46-4.895-11.083a5.37 5.37 0 0 1 5.376-5.376M19.1 20.033a.93.93 0 0 0-.24 1.051l1.742 3.875-8.23 1.682L2.07 20.994l1.832-4.025 4.355-.75a88 88 0 0 0 1.652 2.973 2.35 2.35 0 0 0 2.073 1.201c.87 0 1.622-.45 2.072-1.201.69-1.201 1.442-2.523 2.133-3.844l5.286 2.643z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.97,
    d: "M15.466 7.208a3.487 3.487 0 0 0-3.484-3.484 3.487 3.487 0 0 0-3.484 3.484 3.487 3.487 0 0 0 3.484 3.484 3.487 3.487 0 0 0 3.484-3.484m-5.136 0c0-.9.75-1.652 1.652-1.652.9 0 1.652.751 1.652 1.652s-.751 1.652-1.652 1.652-1.652-.72-1.652-1.652"
  })));
};
export default SvgZone2;